import React from 'react';
import { Link } from 'gatsby';

import { download } from '../../utils/download';

import { firstLinksRowDesktop, bikePortalsGroup, nurseryPortalsGroup } from './helpers';
import {
	ScFooterAddress,
	ScFooterContent,
	ScFooterLink,
	ScFooterLinksGroup,
	ScFooterLinksWrapper,
	ScFooterRow,
	ScFooterRowWrapper,
	ScFooterTitle,
	ScFooterTop,
} from './styled';

export const DesktopFooter = ({ openModal }: { openModal: (modalType: string) => void }) => {
	return (
		<ScFooterTop>
			<ScFooterContent>
				<ScFooterRowWrapper>
					<ScFooterRow>
						<ScFooterLinksWrapper>
							{firstLinksRowDesktop.map((item) => (
								<ScFooterLinksGroup key={item.title}>
									{item.link ? (
										<ScFooterTitle className="no-underline">
											<Link to={item.link}>{item.title}</Link>
										</ScFooterTitle>
									) : (
										<ScFooterTitle
											className={`no-underline${item.onClick ? ' clickable-footer-link' : ''}`}
											onClick={item.onClick}
										>
											{item.title}
										</ScFooterTitle>
									)}
									{item.group?.map((link) => (
										<>
											{link.isContactUsItem ? (
												<ScFooterLink onClick={() => openModal(link.keyword)}>
													{link.title}
												</ScFooterLink>
											) : link.isItDownloadLink ? (
												<ScFooterLink onClick={() => download(link.link)}>
													{link.title}
												</ScFooterLink>
											) : (
												<Link to={link.link} key={link.title}>
													<ScFooterLink>{link.title}</ScFooterLink>
												</Link>
											)}
										</>
									))}
								</ScFooterLinksGroup>
							))}
						</ScFooterLinksWrapper>
					</ScFooterRow>
					<ScFooterRow>
						<ScFooterLinksGroup />
						<ScFooterLinksWrapper>
							<ScFooterLinksGroup>
								<ScFooterTitle className="no-underline">Bike login</ScFooterTitle>
								{bikePortalsGroup.map((link) => (
									<a href={!link.isItDownloadLink && link.link} key={link.title}>
										<ScFooterLink onClick={() => link.isItDownloadLink && download(link.link)}>
											{link.title}
										</ScFooterLink>
									</a>
								))}
							</ScFooterLinksGroup>
							<ScFooterLinksGroup>
								<ScFooterTitle className="no-underline">Nursery login</ScFooterTitle>
								{nurseryPortalsGroup.map((link) => (
									<a href={!link.isItDownloadLink && link.link} key={link.title}>
										<ScFooterLink onClick={() => link.isItDownloadLink && download(link.link)}>
											{link.title}
										</ScFooterLink>
									</a>
								))}
							</ScFooterLinksGroup>
							<ScFooterLinksGroup>
								<ScFooterTitle className="no-underline">
									<Link to={'/faqs/'}>FAQs</Link>
								</ScFooterTitle>
							</ScFooterLinksGroup>
							<ScFooterLinksGroup>
								<ScFooterTitle>&nbsp;</ScFooterTitle>
								<Link to={'/cookie-policy/'}>
									<ScFooterLink>Cookies</ScFooterLink>
								</Link>
								<Link to={'/privacy-policy/'}>
									<ScFooterLink>Privacy Policy</ScFooterLink>
								</Link>
								<Link to={'/terms-and-conditions/'}>
									<ScFooterLink>Terms & Conditions</ScFooterLink>
								</Link>
							</ScFooterLinksGroup>
						</ScFooterLinksWrapper>
					</ScFooterRow>
				</ScFooterRowWrapper>
				<ScFooterAddress>
					© 2026 Velomatch Limited t/a gogeta. Velomatch Limited t/a gogeta is a registered company
					in England and Wales as Velomatch Limited (No. 13403344). Our registered address is
					Birchin Court, 20 Birchin Lane, London EC3V 9DU. We are authorised and regulated by the
					Financial Conduct Authority under registration number 994240.
				</ScFooterAddress>
			</ScFooterContent>
		</ScFooterTop>
	);
};
